import GeneralFilter from '../../../../Model/GeneralFilter'

export default class JockeyFilter extends GeneralFilter {
  constructor () {
    super()
    this.setInitialValue()
  }

  setInitialValue () {
    this.setFilterInitialValue()
  }
}
